<template>
    <div>
        <app-burger :class="{ active: showMenu }" @onToggle="navToggle"></app-burger>

        <nav class="nav" :class="{ show: showMenu }">
            <a class="nav__item" href="https://re.pastorius.lv/" target="_blank">{{ $t("message.real_estate") }}</a>
            <a class="nav__item" href="https://lakonik.eu/" target="_blank">{{ $t("message.it_solutions") }}</a>
            <a class="nav__item" href="https://hk.pastorius.lv/" target="_blank">{{ $t("message.housekeeping") }}</a>
        </nav>
    </div>
</template>


<script>
    export default {
        data () {
            return {
                showMenu: false
            }
        },
        methods: {
            navToggle() {
                this.showMenu = !this.showMenu;
            }
        }
    }
</script>


<style lang="scss">
    $nav-bg: #21282d;

    .nav {
        width: 100%;

        position: absolute;
        top: 100%;
        left: 0;
        z-index: 1;

        transform: translateX(-100%);
        transition: transform .2s linear;

        &.show {
            transform: translateX(0);
        }
    }

    .nav__item {
        display: block;
        padding: 1rem 0 1rem 5rem;

        background-color: $nav-bg;

        font-size: 1.2rem;
        font-weight: 700;
        color: #fff;
        text-transform: uppercase;
        text-decoration: none;

        transition: background .1s linear;

        &:hover {
            background-color: lighten($nav-bg, 5%);
        }

        @media (max-width: 1199px) {
            font-size: 1rem;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Nav.vue